/**
 * Tooltip positioning utilities built on top of Floating UI.
 * @see https://floating-ui.com/docs/platform
 * @license MIT - Floating UI is licensed under MIT
 */
import { computePosition as computePositionFloating, } from '@floating-ui/dom';
import { TooltipAlignType } from '../types/tooltipAlign';
// Conversion map between your types and floating-ui types
const placementMap = {
    [TooltipAlignType.TOP]: 'top',
    [TooltipAlignType.BOTTOM]: 'bottom',
    [TooltipAlignType.LEFT]: 'left',
    [TooltipAlignType.RIGHT]: 'right',
};
// Reverse map to convert from floating-ui to your types
const reversePlacementMap = {
    top: TooltipAlignType.TOP,
    bottom: TooltipAlignType.BOTTOM,
    left: TooltipAlignType.LEFT,
    right: TooltipAlignType.RIGHT,
};
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 */
export const computePosition = async (reference, floating, config) => {
    const { placement = TooltipAlignType.TOP, strategy = 'fixed', middleware = [] } = config;
    // Convert position from TooltipAlignType to floating-ui Placement
    const floatingPlacement = placementMap[placement] || 'top';
    // Call floating-ui's computePosition function
    const result = await computePositionFloating(reference, floating, {
        placement: floatingPlacement,
        strategy,
        middleware,
    });
    // Convert resulting position from Placement to TooltipAlignType
    const tooltipPlacement = reversePlacementMap[result.placement] || TooltipAlignType.TOP;
    return {
        x: result.x,
        y: result.y,
        placement: tooltipPlacement,
        strategy: result.strategy,
        middlewareData: result.middlewareData,
    };
};
//# sourceMappingURL=computePosition.js.map